import PropTypes from "prop-types";
import React from "react";

import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoSm from "../../assets/images/cluedinimage/Group.png";
import logoDark from "../../assets/images/cluedinimage/Group.png";
import logoLight from "../../assets/images/cluedinimage/Group.png";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = (props) => {
  const location = useLocation();

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  return (
    <React.Fragment>
      <style>
        {`
          .nav-tab-link {
            color: #A9A9A9;
            text-decoration: none;
            padding: 8px 16px;
            margin-right: 10px;
            font-size: 15px;
            font-weight: 500;
          }
          .nav-tab-link:hover {
            color: #fff;
          }
          .nav-tab-link.active {
            color: #fff;
            border-bottom: 2px solid #fff;
          }
        `}
      </style>
      <header id="page-topbar" style={{ backgroundColor: "#343333" }}>
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="40" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="logo-dark" height="40" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="40" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="40" />
                </span>
              </Link>
            </div>

            {/* Navigation Tabs */}
            <div className="d-flex ms-4">
              <Link
                to="/dashboard"
                className={`nav-tab-link ${
                  location.pathname === "/dashboard" ? "active" : ""
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/messages"
                className={`nav-tab-link ${
                  location.pathname === "/messages" ? "active" : ""
                }`}
              >
                Messages
              </Link>
            </div>
          </div>

          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i
                  className="ri-fullscreen-line"
                  style={{ color: "#A9A9A9" }}
                />
              </button>
            </div>

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
